var map = {
	"./strings.en-US.resjson": [
		48485,
		8485
	],
	"./strings.en.resjson": [
		96124,
		6124
	],
	"./strings.ja-JP.resjson": [
		41301,
		1301
	],
	"./strings.ja.resjson": [
		83286,
		3286
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 48209;
module.exports = webpackAsyncContext;